
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Index from "./pages/Index";
import Contact from "./pages/Contact";
import PrivacyCookiebeleid from "./pages/PrivacyCookiebeleid";
import Disclaimer from "./pages/Disclaimer";
import NotFound from "./pages/NotFound";
import DealsPage from "./pages/DealsPage";
import LuxuryPage from "./pages/LuxuryPage";
import RondreizenPage from "./pages/RondreizenPage";
import AllVacationsPage from "./pages/AllVacationsPage";
import ResultatenPage from "./pages/ResultatenPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import FavoritesPage from "./pages/FavoritesPage";
import { LocalFavoritesSection } from "./components/LocalFavoritesSection";

const queryClient = new QueryClient();

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleShowAllVacations = () => {
    navigate('/alle-vakanties');
  };

  const handleShowDeals = () => {
    navigate('/deals');
  };

  const handleShowLuxury = () => {
    navigate('/luxe');
  };

  const handleShowRondreizen = () => {
    navigate('/rondreizen');
  };

  const handleShowFavorites = () => {
    navigate('/favorieten');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const getCurrentView = () => {
    if (location.pathname === '/contact') return 'contact';
    if (location.pathname === '/disclaimer') return 'disclaimer';
    if (location.pathname === '/privacy-cookiebeleid') return 'privacy';
    if (location.pathname === '/deals') return 'deals';
    if (location.pathname === '/luxe') return 'luxury';
    if (location.pathname === '/rondreizen') return 'rondreizen';
    if (location.pathname === '/alle-vakanties') return 'all';
    if (location.pathname === '/favorieten') return 'favorites';
    if (location.pathname === '/resultaten') return 'search';
    if (location.pathname === '/admin-analytics') return 'analytics';
    return 'home';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 flex flex-col">
      <Toaster />
      <Sonner />
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowFavorites={handleShowFavorites}
        onGoHome={handleGoHome}
        currentView={getCurrentView()}
      />
      <main className="container mx-auto px-4 py-8 flex-grow">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/luxe" element={<LuxuryPage />} />
          <Route path="/rondreizen" element={<RondreizenPage />} />
          <Route path="/alle-vakanties" element={<AllVacationsPage />} />
          <Route path="/favorieten" element={<FavoritesPage />} />
          <Route path="/resultaten" element={<ResultatenPage />} />
          <Route path="/admin-analytics" element={<AnalyticsPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-cookiebeleid" element={<PrivacyCookiebeleid />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <LocalFavoritesSection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
